import {
  resolveDynamicFlag,
  useDynamicFlag,
} from "@/utils/featureFlagOverride";

const GENERAL_FLAG_KEY = "VITE_FF_SETTINGS_PAGE_GENERAL";
const generalEnvValue =
  import.meta.env.VITE_FF_SETTINGS_PAGE_GENERAL === "true";

export const useIsUserManagementEnabled = () =>
  useDynamicFlag(GENERAL_FLAG_KEY, generalEnvValue);

const TEXT_FLAG_KEY = "VITE_FF_SETTINGS_PAGE_TEXT";
const textEnvValue = import.meta.env.VITE_FF_SETTINGS_PAGE_TEXT === "true";

export const useIsTextRegistrationEnabled = () =>
  useDynamicFlag(TEXT_FLAG_KEY, textEnvValue);

const BILLING_FLAG_KEY = "VITE_FF_SETTINGS_PAGE_BILLING";
const billingEnvValue =
  import.meta.env.VITE_FF_SETTINGS_PAGE_BILLING === "true";

export const isBillingPageEnabled = () =>
  resolveDynamicFlag(BILLING_FLAG_KEY, billingEnvValue);

export const useIsBillingPageEnabled = () =>
  useDynamicFlag(BILLING_FLAG_KEY, billingEnvValue);

const SMS_REGISTRATION_FLAG_KEY = "VITE_FF_SMS_REGISTRATION";
const smsRegistrationEnvValue =
  import.meta.env.VITE_FF_SMS_REGISTRATION === "true";

export const isSmsRegistrationEnabled = () =>
  resolveDynamicFlag(SMS_REGISTRATION_FLAG_KEY, smsRegistrationEnvValue);

export const useIsSmsRegistrationEnabled = () =>
  useDynamicFlag(SMS_REGISTRATION_FLAG_KEY, smsRegistrationEnvValue);
